module.exports = __webpack_public_path__ + "static/media/private-office-icon--hover.c3be29fb.svg";